import css from './dashboardTile.module.css'
import { IDashboard } from '@/pages/Dashboards/dashboards.types.ts'
import useDashboard from '@/pages/Dashboards/hooks/useDashboard.ts'
import DashboardIcon from '@/assets/icons/dashboard.svg?react'
import DropdownUnderThreeDots from '@/shared/Dropdowns/DropdownUnderThreeDots'
import usePopup from '@/shared/hooks/usePopup.ts'
import { useRef, useState } from 'react'
import DropdownListItemDelete from '@/shared/Dropdowns/DropdownListItem/DropdownListItemDelete'
import DropdownListItemSettings from '@/shared/Dropdowns/DropdownListItem/DropdownListItemSettings'
import DropdownListItemCopy from '@/shared/Dropdowns/DropdownListItem/DropdownListItemCopy'
import DropdownListItemGoTo from '@/shared/Dropdowns/DropdownListItem/DropdownListItemGoTo'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import dashboardsEvents from '@/pages/Dashboards/events/dashboards.events.ts'
import dashboardsApi from '@/pages/Dashboards/dashboards.api.ts'
import UpdateDashboardModal from '@/pages/Dashboards/components/Modals/UpdateDashboardModal'
import { useNavigate } from 'react-router-dom'
import urls from '@/navigation/urls.ts'
import domUtils from '@/utils/dom.utils.ts'
import userUtils from '@/pages/User/user.utils.ts'

interface IProps {
  dashboardId: IDashboard['id']
}

const DashboardTile = (props: IProps) => {
  const ref = useRef()
  const navigate = useNavigate()
  const { open: menuOpen, setOpen: setMenuOpen } = usePopup(ref)
  const [updateModalOpen, setUpdateModalOpen] = useState(false)

  const dashboard = useDashboard(props.dashboardId)

  const handleDelete = () => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление дашборда "${dashboard.name}"`,
      buttonType: 'primary',
      onConfirm: () =>
        dashboardsApi
          .deleteDashboard(dashboard.id)
          .then((r) => r.status === 'success' && dashboardsEvents.deleted(r.body.id)),
    })
  }

  if (!dashboard) return null
  return (
    <div className={css.dashboardTileWrapper}>
      <UpdateDashboardModal
        dashboardId={dashboard.id}
        open={updateModalOpen}
        onClose={() => setUpdateModalOpen(false)}
      />
      <div className="flex-lines gap8 width100">
        <div
          onDoubleClick={(ev) => {
            ev.preventDefault()
            ev.stopPropagation()

            navigate('/dashboards/' + dashboard.id)
          }}
          className={css.dashboardIconWrapper}
          onContextMenu={(ev) => {
            ev.stopPropagation()
            ev.preventDefault()

            setMenuOpen(true)
          }}
        >
          <div className={css.dashboardTileThreeDotsWrapper}>
            <DropdownUnderThreeDots open={menuOpen} setOpen={setMenuOpen} ref={ref} position="left">
              <DropdownListItemGoTo
                text="В новой вкладке"
                onClick={() => domUtils.openLink(urls.dashboards + '/' + dashboard.id)}
              />
              <DropdownListItemCopy text="Создать копию" onClick={() => {}} />
              <DropdownListItemSettings text="Настройки" onClick={() => setUpdateModalOpen(true)} />
              <DropdownListItemDelete text="Удалить" onClick={handleDelete} />
            </DropdownUnderThreeDots>
          </div>
          <DashboardIcon />
        </div>
        <div className="flex-lines">
          <p className="text-nm">{dashboard.name}</p>
          <p className="text-nm text-secondary">Автор: {userUtils.getFullName(dashboard.ownedBy?.userInfo) || '—'}</p>
        </div>
      </div>
    </div>
  )
}

export default DashboardTile
